import { render, staticRenderFns } from "./client.vue?vue&type=template&id=464fc15e&"
import script from "./client.vue?vue&type=script&lang=js&"
export * from "./client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('464fc15e')) {
      api.createRecord('464fc15e', component.options)
    } else {
      api.reload('464fc15e', component.options)
    }
    module.hot.accept("./client.vue?vue&type=template&id=464fc15e&", function () {
      api.rerender('464fc15e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/select/client.vue"
export default component.exports